"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdMessageLabel = void 0;
var Label_1 = require("../labels/Label");
/**
 * A label that displays a message regarding the ad that's currently being played.
 *
 * @category Labels
 */
var AdMessageLabel = /** @class */ (function (_super) {
    __extends(AdMessageLabel, _super);
    function AdMessageLabel(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, config) || this;
        _this.config = _this.mergeConfig(config, {
            cssClass: 'ui-ad-message-label',
        }, _this.config);
        return _this;
    }
    AdMessageLabel.prototype.configure = function (player, uimanager) {
        var _this = this;
        _super.prototype.configure.call(this, player, uimanager);
        var clearText = function () {
            _this.setText('');
        };
        clearText();
        player.on(player.exports.PlayerEvent.SourceUnloaded, clearText);
        player.on(player.exports.PlayerEvent.AdError, clearText);
        player.on(player.exports.PlayerEvent.AdSkipped, clearText);
        player.on(player.exports.PlayerEvent.AdFinished, clearText);
        player.on(player.exports.PlayerEvent.AdStarted, function (event) {
            var _a, _b;
            var ad = event.ad;
            if (!ad.isLinear) {
                return;
            }
            var linearAd = ad;
            _this.setText((_b = (_a = linearAd.uiConfig) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : '');
        });
    };
    return AdMessageLabel;
}(Label_1.Label));
exports.AdMessageLabel = AdMessageLabel;
